import styles from "./tagMapping.module.css";
import SupportingStyles from './SupportingDocument.module.css'
import { useEffect, useState } from "react";
import { ADD_SUPPORTING_DOCS, BASE_URL, GET_SUPPORTING_DOCS, SUBMIT_TAGS, USER_TOKEN } from "../../Utils/constant";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/Loader";
import cogoToast from "cogo-toast-react-17-fix";
import useRefreshToken from "../../Hooks/usegenerateToken";
import API from "../../ApiConfig"
import { BUTTONS, MESSAGE } from "../../Utils/Strings";
import CustomCheckDropDown from "../../components/CustomCheckDropDown";
import IssuerNavigator from "../../components/DashBoard/IssuerNavigator";
import Breadcrumb from "../../components/Verifier/breadcrumb/BreadCrumb";

const SupportingDocument = ({ id,doc_name }) => {
  useRefreshToken(BASE_URL + USER_TOKEN)

  const navigate = useNavigate();

  const [TagList, setTaglist] = useState(Array(7).fill().map((_, index) => index + 1))
  const [loading, setLoading] = useState(false)
  const [submit, setsubmit] = useState(false)
  const [supportingDocs, setSupportingDocs]=useState(Array(7).fill().map((_, index) => index + 1))
  const getSupportingDocsList = () => {

    const cleanupData = (data) => {
      data.map(item => {
        let sourceSelected = false
        sourceSelected = item.master_document.some(item => item.checked)
        item.sourceSelected = sourceSelected
      })
      return data
    }
    setLoading(true)
    API.get(GET_SUPPORTING_DOCS + id)
      .then(data => {
        let res = data.data
        if (res.data) {
          setTaglist(cleanupData(res.data))
        }
        setLoading(false)
      })
      .catch(err =>
        cogoToast.error(err.message)
      )
  }

  useEffect(() => {
    getSupportingDocsList()
  }, [])

  function handleSourceChange(sIndex, lIndex) {
    let temp = [...TagList]
    temp[lIndex].master_document[sIndex].checked = !temp[lIndex].master_document[sIndex].checked
    let sourceSelected = false
    sourceSelected = temp[lIndex].master_document.some(item => item.checked)
    temp[lIndex].sourceSelected = sourceSelected
    setTaglist(temp)
    setSupportingDocs(temp)
  }

  const submitTags = () => {
    setsubmit(true)
    const filterData = () => {
      return TagList.map((item) => {
        const selectedMasterDocs = item.master_document
          .filter((doc) => doc.checked)
          .map((doc) => doc.master_document_id);
        return {
          doc_field_id: item.doc_field_id,
          master_document_ids: selectedMasterDocs
        };
      })
        .filter(Boolean);
    }

    let formData = filterData()
    API.post(ADD_SUPPORTING_DOCS + id, formData)
      .then(data => {
        let res = data.data
        if (res.status == 200) {
          navigate('/Create/' + id + '/Layout')
          cogoToast.success(res.data)
        }
        else {
          cogoToast.error("some error occured while saving the tags")
        }
      })
      .catch(err => {
        cogoToast.error(err.response.data.detail)
      }
      )
      .finally(() => {
        setsubmit(false)
      })
  }
  const supportAction = () => {
    return (
        <div className="navItemContainer">
            <button className="btn btn-primary" onClick={e=>submitTags(e)} style={{ width: '10rem' }}>Submit <img src='/rightchevron.svg' loading='lazy' alt='rightchevron.svg'/></button>
        </div>
    )
}
  return (
    <>
    <Breadcrumb title={"Create New Template"} pos={2} category={"template"}/>
    <IssuerNavigator title="Supporting Documents" step={"/Create/"+ id + "/Mapping"}  actions={supportAction}/>
    <div className={styles.SupportMappingBody}>
      <Loader isOpen={loading} />
      <div className={styles.Supportselected}>
        {/* <div className={styles.tableheader} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <h1 className={styles.tableheader + " " + styles.search}>
            {loading ? <div className="shimmer" style={{ width: "10rem" }}></div> : <>Supporting Documents</>}
          </h1>
          <div className={styles.search}><button className={styles.Button} onClick={e => submitTags(e)} disabled={submit}>{submit ? 'Submitting...' : BUTTONS.SUBMIT}</button></div>
        </div> */}
        <div className={null} style={{ padding: '0rem 1rem' }}>
          {/* <div className={[styles.tableheader, styles.search].join(" ")} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}> */}
            <h2 className={styles.tableheader}>
              {loading ? <div className="shimmer" style={{ width: "30rem" }}></div> : <>
              <h1 className={styles.tableheader + " " + styles.search} style={{padding:"10px"}}>{loading ? <div className="shimmer" style={{ width: "10rem" }}></div> : <><div className={styles.tagType}>Document Name</div> <div>{doc_name}</div></>}</h1>
              </>}
            </h2>
          {/* </div> */}
          <table>
            <tr>
              <th className={styles.th}>Variable ({TagList.length})</th>
              <th className={styles.th}>Dynamic Tags</th>
              <th className={styles.th}>Document</th>
              <th className={styles.th}>Supporting Document</th>
            </tr>
            {TagList.map((el, index) => {
              return (
                // <tr key={el.field_id} style={el.is_default ? { opacity: 0.5 } : null}>
                <tr key={el.field_id}>
                  <td className={styles.td}>
                    {loading ?
                      <>
                        <div className="shimmer" style={{ width: '10rem' }}></div>
                        <div className="shimmer"></div>
                      </> :
                      <div className={SupportingStyles.tableData}>
                        <span className={SupportingStyles.docHeading}>{el.field_name}</span><br></br>
                        {/* {el.description} */}
                      </div>}
                  </td>
                  <td className={styles.td}>
                    {loading ?
                      <>
                        <div className="shimmer"></div>
                      </> :
                      <div className={SupportingStyles.tableData}>
                        <span className={SupportingStyles.docHeading}>{`{${el.field_name}}`}</span><br></br>
                      </div>}
                  </td>
                  <td className={styles.td} style={{ width: '15rem' }}>
                    {loading ? <div className="shimmer" style={{ marginTop: '10px', width: 'inherit', height: '2.5rem' }}></div>
                      : <CustomCheckDropDown
                        isSelected={el.sourceSelected}
                        label={MESSAGE.SELECT_SUPPORT_DOCUMENT_DROPDOWN}
                        onSelect={e => handleSourceChange(e, index)}
                        list={el.master_document}
                        displayKey="master_document_name"
                        selectedOption={el?.selected}
                      />}
                  </td>
                  <td className={styles.td}>
                    {loading ?
                      <>
                        <div className="shimmer"></div>
                      </> :
                      <div className={SupportingStyles.tableData} style={{fontWeight:"500", display:"flex", alignItems:"center"}}>
                        <span className={styles.supportDoc}>{el.master_document &&   el.master_document.map((item)=>(
                          <div className={item.checked?styles.supportingDocuments:null}>{item.checked && item.master_document_name}</div>
                          ))}</span><br></br>
                      </div>}
                  </td>
                </tr>
              )
            })}
          </table>
        </div>
      </div>
      <div>
          <div className={styles.tagInfo}>
            {loading?<div className="shimmer" style={{width:"24rem", height:"7rem"}}></div>:
            <>
            <span style={{fontWeight:"500"}}>What are dynamic tags</span><br/>
            <span className={styles.text}>Insert the dynamic tags description here. It would look better as two lines of text.</span><br/>
            <span className={styles.learnMore}>Learn More</span>
            </>}
          </div>
          <div className={styles.tagInfo}>
            {loading?<div className="shimmer" style={{width:"24rem", height:"7rem"}}></div>:
            <>
            <span style={{fontWeight:"500"}}>What is supporting document?</span><br/>
            <span className={styles.text}>Insert the dynamic tags description here. It would look better as two lines of text.</span><br/>
            <span className={styles.learnMore}>Learn More</span>
            </>}
          </div>
        </div>
    </div>
    </>
  );
};

export default SupportingDocument;
